module.exports = __webpack_public_path__ + "static/img/1_0031.34005ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0031.jpg
// module id = KkEL
// module chunks = 0